module.exports = __webpack_public_path__ + "img/blue_ic_trackorder.3f0a33eb.svg";